














































import { Component, Vue, Watch, Prop, Emit } from 'vue-property-decorator';

@Component
export default class Button extends Vue {
  @Prop({ type: String, required: false }) private type!: string;
  @Prop({ default: 1, required: false }) private length!: any;
  private created() {
    // console.log(this.btnObj);
  }

  @Emit('change')
  private clickEmit(value: any) {
    return value;
  }
}
